<!-- <pre>{{addressBook$ | async | json}}</pre> -->
<div class="lessors_module">
  <div class="lessors tab_content" id="content9" data-tab="9">

<ng-container [ngSwitch]="task">
  <ng-template ngSwitchCase="list">

<cradua-lessor-header
[activitySelectedValue]="activitySelectedValue"
[ownershipTypes]="ownershipTypes"
[banks]="banks"
(emitAddressBook)="onAddressBook($event)"
(emitCreateAddressBook)="onCreateAddressBook($event)"
></cradua-lessor-header>

<cradua-lessor-info-list
[lessorInfos]="lessorInfos"
[individualAcreages]="individualAcreages"
[lessorRepresentatives]="lessorRepresentatives"
[addressBooks]="addressBooks"
[lessorRepTypes]="lessorRepTypes"
[banks]="banks"
(emitLessorInfo)="onEmitLessorView($event)"
(emitLessorInfoDelete)="onEmitLessorInfoDelete($event)"
>
</cradua-lessor-info-list>
  </ng-template>
  <ng-template ngSwitchCase="view">

  <cradua-lessor-main-view
  [selectedLessorInfo]="selectedLessorInfo"
  [ownershipTypes]="ownershipTypes"
  [lessorRepTypes]="lessorRepTypes"
  [terrains]="terrains"
  [measures]="measures"
  [banks]="banks"
  [isLoadingLessorRepresentative]="isLoadingLessorRepresentative"
  [isLoadingLessorStakeholder]="isLoadingLessorStakeholder"
  [isLoadingIndividualAcreages]="isLoadingIndividualAcreages"
  [isLoadingLessorAreaMaker]="isLoadingLessorAreaMaker"
  [lessorAreaMakers]="lessorAreaMakers"
  [lessorRepresentatives]="lessorRepresentatives"
  [lessorStakeholders]="lessorStakeholders"
  [individualAcreages]="individualAcreages"
  [addressBooks]="addressBooks"
  [selectedLandTitle]="selectedLandTitle"
  (emitTask)="onBack($event)"
  (emitLessorAreaMaker)="onEmitLessorAreaMaker($event)"
  (emitLessorAreaMakerDelete)="onEmitLessorAreaMakerDelete($event)"
  (emitLessorRepresentative)="onEmitLessorRepresentative($event)"
  (emitLessorStakeholder)="onEmitLessorStakeholder($event)"
  (emitLessorRepresentativeDelete)="onEmitLessorRepresentativeDelete($event)"
  (emitLessorStakeholderDelete)="onEmitLessorStakeholderDelete($event)"
  (emitIndividualAcreages)="onEmitIndividualAcreages($event)"
  (emitIndividualAcreagesDelete)="onEmitIndividualAcreagesDelete($event)"
  >
  </cradua-lessor-main-view>

</ng-template>
</ng-container>
</div>
</div>
